var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoErrorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 153 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("mask", {
    id: "video-error-icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 153,
    height: 152
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.5 0h152v152H.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#video-error-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.848 96.267h31.034c1.372 0 2.507-.449 3.404-1.346.897-.897 1.346-2.032 1.346-3.404v-11.4l14.408 11.558c1.161.95 2.428 1.082 3.8.396 1.372-.686 2.058-1.768 2.058-3.246v-25.65c0-1.478-.686-2.56-2.058-3.246-1.372-.686-2.639-.554-3.8.396L86.632 71.883v-11.4c0-1.372-.449-2.507-1.346-3.404-.897-.897-2.032-1.346-3.404-1.346H50.848c-1.372 0-2.506.449-3.404 1.346-.897.897-1.346 2.032-1.346 3.404v31.034c0 1.372.45 2.507 1.346 3.404.898.897 2.032 1.346 3.404 1.346zm-19.95 22.166c-2.744 0-5.014-.897-6.808-2.691-1.794-1.795-2.692-4.064-2.692-6.809V43.067c0-2.745.898-5.014 2.692-6.809 1.794-1.794 4.064-2.691 6.808-2.691h91.2c2.745 0 5.014.897 6.809 2.691 1.794 1.795 2.691 4.064 2.691 6.809v65.866c0 2.745-.897 5.014-2.691 6.809-1.795 1.794-4.064 2.691-6.809 2.691h-91.2zm0-4.433h91.2c1.478 0 2.692-.475 3.642-1.425.95-.95 1.425-2.164 1.425-3.642V43.067c0-1.478-.475-2.692-1.425-3.642-.95-.95-2.164-1.425-3.642-1.425h-91.2c-1.477 0-2.691.475-3.641 1.425-.95.95-1.425 2.164-1.425 3.642v65.866c0 1.478.475 2.692 1.425 3.642.95.95 2.164 1.425 3.641 1.425z",
    fill: "#fff"
  })))));
}
export default SvgVideoErrorIcon;